import { Icon, Text } from "@zapier/design-system";
import { Tooltip } from "@zapier/design-system-beta";
import styles from "./HiddenZapStep.module.css";

export function HiddenZapStep() {
  return (
    <div className={styles.root}>
      <Text type="SmallPrint3" color="PrimeWhite">
        Steps hidden
      </Text>
      <Tooltip
        placement="top"
        content="Step counts and titles are unavailable."
      >
        <Tooltip.FocusableTrigger>
          <Icon name="alertInfoFill" size={16} color="PrimeWhite" />
        </Tooltip.FocusableTrigger>
      </Tooltip>
    </div>
  );
}
